const Counters = () => {

    const counters = document.getElementsByClassName('counters')[0];
    const countersElements = document.getElementsByClassName('counters__item-number-js');
    const body = document.getElementsByTagName('body')[0];

    if(counters) {
        var executed = false;
        function countNumbers() {
            if (!executed) {
                executed = true;
                Array.prototype.forEach.call (countersElements, function (node) {
                    var counter = 0;
                    var speed = 0;
                    if(node.dataset.number < 10) {
                        speed = 80;
                    } else if(node.dataset.number > 10 && node.dataset.number < 50) {
                        speed = 50;
                    } else {
                        speed = 5;
                    }
                    var interval = setInterval(function(){ 
                        if (counter == node.dataset.number) clearInterval(interval);
                        node.innerHTML = counter; 
                        counter++;
                    }, speed);
                
                } );
            }
        }

        window.addEventListener('scroll',function() {
            const topOffset = body.getBoundingClientRect().top;
            var topPos = counters.getBoundingClientRect().top + window.scrollX;
            if(Math.abs(topOffset) > topPos + 200) {
                countNumbers();
            }
        })
    }

}

export default Counters;